import { Button } from '@ver-uds/react';
import { useAccordionContext } from '@ver-uds/uswds-react';
import React from 'react';

export type FiltersButtonProps = {
  controls: string;
};

const FiltersButton = ({ controls }: FiltersButtonProps): JSX.Element => {
  const { isOpen, toggle } = useAccordionContext();
  const showMenu = isOpen(controls);
  return (
    <Button
      type="button"
      variant="inverse"
      className="ver-button--default-focus margin-right-0"
      aria-expanded={showMenu}
      aria-controls={controls}
      onClick={() => toggle(controls)}
    >
      {showMenu ? 'Hide Filters' : 'Show Filters'}
    </Button>
  );
};

export default FiltersButton;
